import styled from "@emotion/styled";
import { range } from "es-toolkit";

import type { NodeTemplate } from "@skilitics/nautilus-endpoint-definition";

import { TemplateCard, TemplateCardSkeleton } from "./TemplateCard";

const Container = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  column-gap: 2.5%;
  row-gap: 20px;
`;

type Props = {
  querying: boolean;
  templates: NodeTemplate[];
  onSelect: (template: NodeTemplate) => void;
  onConfirm: (template: NodeTemplate) => void;
  selectedTemplateId?: NodeTemplate["id"];
  isUnavailable: (template: NodeTemplate) => boolean;
};

export const TemplateCards = ({
  querying,
  templates,
  onSelect,
  onConfirm,
  selectedTemplateId,
  isUnavailable,
}: Props) => (
  <Container data-test="template-cards-container">
    {querying
      ? range(0, 9).map((key) => <TemplateCardSkeleton key={key} />)
      : templates.map((template) => (
          <TemplateCard
            key={template.id}
            title={template.title}
            selected={selectedTemplateId === template.id}
            unavailable={isUnavailable(template)}
            thumbnailAssetId={template.thumbnailAssetId}
            onSelect={() => onSelect(template)}
            onConfirm={() => onConfirm(template)}
            data-test="template-card"
          />
        ))}
  </Container>
);
